import { render, staticRenderFns } from "./gradeRule.vue?vue&type=template&id=65a49a22&scoped=true"
import script from "./gradeRule.vue?vue&type=script&lang=js"
export * from "./gradeRule.vue?vue&type=script&lang=js"
import style0 from "./gradeRule.vue?vue&type=style&index=0&id=65a49a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a49a22",
  null
  
)

export default component.exports